import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { AnalyticsStructurePieResult, AnalyticsStructureSingleValue } from 'src/app/models/ianalytics.interface';
import { ChartOptionsPie } from 'src/app/models/igraph.model';
import { GLOBAL_VARIABLES } from '../../data/const.data';

@Component({
  selector: 'app-structure-graph-pie',
  templateUrl: './structure-graph-pie.component.html',
  styleUrls: ['./structure-graph-pie.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StructureGraphPieComponent implements OnInit, OnChanges {
  @Input() data: AnalyticsStructurePieResult;
  @Input() isOptimized: boolean = true;
  @Input() percentOptimized: number = 5;

  graphOptions: Partial<ChartOptionsPie>;

  constructor() {}

  ngOnInit(): void {
    this.updateGraphOptions(); // Инициализация при первом рендере
  }

  ngOnChanges(): void {
    this.updateGraphOptions(); // Обновление при изменении данных
  }

  private updateGraphOptions(): void {
    if (!this.data || !Array.isArray(this.data.data)) {
      console.error('Invalid or missing data for pie graph:', this.data);
      this.graphOptions = undefined;
      return;
    }

    const stat = this.isOptimized
      ? this.prepareOptimizedData(this.data.data, this.percentOptimized)
      : this.data.data;

    if (stat.length === 0) {
      console.error('No valid statistics data after optimization:', stat);
      this.graphOptions = undefined;
      return;
    }

    this.graphOptions = {
      series: stat.map(el => el.value),
      colors: GLOBAL_VARIABLES.COLORS.slice(0, stat.length), // Используем длину stat
      chart: {
        type: 'donut',
        height: 480,
        toolbar: { show: true }
      },
      title: {
        text: this.data.caption || 'График'
      },
      legend: {
        position: 'right',
        onItemClick: { toggleDataSeries: true },
        onItemHover: { highlightDataSeries: true }
      },
      tooltip: {
        enabled: true,
        custom: ({ series, seriesIndex, w }) => {
          const total = series.reduce((sum: number, x: number) => sum + x, 0);
          const selected = series[seriesIndex];
          return (
            '<span style="padding: 0.25em;">' +
            `${w.config.labels[seriesIndex]}: ${selected} (${(selected / total * 100).toFixed(2)}%)` +
            '</span>'
          );
        }
      },
      labels: stat.map(el => el.key)
    } as Partial<ChartOptionsPie>;

  }

  private prepareOptimizedData(data: AnalyticsStructureSingleValue[], optimize: number): AnalyticsStructureSingleValue[] {
    const more = data.filter(o => o.percent >= optimize);
    const less = data
      .filter(o => o.percent < optimize)
      .reduce(
        (a, b) =>
          ({
            key: 'Другое',
            value: a.value + b.value,
            percent: a.percent + b.percent
          } as AnalyticsStructureSingleValue),
        { key: '', value: 0, percent: 0 } as AnalyticsStructureSingleValue
      );

    return less.value > 0 ? [...more, less] : more; // Добавляем "Другое" только если есть значения
  }
}
